// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3klwb","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3Abpj"};